/**
 * Vas Service Management Platform
 * VAS Service Managment Api 
 *
 * OpenAPI spec version: v1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * 
 */
export type PlanInterval = 0 | 1 | 2 | 3 | 4 | 5;

export const PlanInterval = {
    NUMBER_0: 0 as PlanInterval,
    NUMBER_1: 1 as PlanInterval,
    NUMBER_2: 2 as PlanInterval,
    NUMBER_3: 3 as PlanInterval,
    NUMBER_4: 4 as PlanInterval,
    NUMBER_5: 5 as PlanInterval
};
